import React, { useEffect } from "react";
import ButtonList from "../../../../components/ButtonList";
import LinkButton from "../../../../components/LinkButton";
import {
  deleteAggregateAuxData,
  updateAggregateAuxData
} from "./AggregateAuxUpdateUtil";

import styles from "./../RecordTable.module.scss";

const AuxDataOptions = ({
  onClickAuxDataUpdateAction,
  onClickAuxDataUpdateButton,
  detailsMap,
  disableInactiiveAndInvalid,
  disableReplace,
  extension
}) => {
  const [rowPopOverVisible, setRowPopOverVisible] = React.useState(false);
  const [auxDataUpdateOptions, setAuxDataUpdateOptions] = React.useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      event.preventDefault();
      event.stopPropagation();
      if (rowPopOverVisible && event.target.tagName !== "P") {
        setRowPopOverVisible(false);
      }
      if (auxDataUpdateOptions && event.target.tagName !== "P") {
        setAuxDataUpdateOptions(false);
      }
    }
    //Bind the event listener
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [rowPopOverVisible, auxDataUpdateOptions]);

  const handleOnclickAction = (event, action) => {
    event.stopPropagation();
    event.preventDefault();
    detailsMap["Mark as"] = action;
    onClickAuxDataUpdateAction(detailsMap);
    setRowPopOverVisible(false);
    setAuxDataUpdateOptions(false);
  };

  let divWidth = detailsMap.Field.includes("Address") ? "25%" : "10%";

  return (
    <div>
      <div style={{ position: "relative", width: divWidth, float: "left" }}>
        <LinkButton
          icon="menu_hidden"
          onClick={() => setRowPopOverVisible(!rowPopOverVisible)}
        />
        <ButtonList
          className={`${styles.overrideOutsideButton} ${
            rowPopOverVisible ? styles.isVisible : ""
          }`}
          vertical
          spacing="0.2"
        >
          <LinkButton
            className={styles.insidebutton}
            onClick={event =>
              handleOnclickAction(event, updateAggregateAuxData)
            }
          >
            <p>Update</p>
          </LinkButton>
          <LinkButton
            className={styles.insidebutton}
            onClick={event =>
              handleOnclickAction(event, deleteAggregateAuxData)
            }
          >
            <p>Delete</p>
          </LinkButton>
        </ButtonList>
      </div>
    </div>
  );
};

export default AuxDataOptions;
